<form name="frmAdminFeedback"  style="margin-top:-1.5%;">
    <div class="container panel panel-default col-md-12" style="padding-left:0%;padding-right:0%;border-color:black;min-height:80vh;background-color: #f4f8f6;">
        <div class="panel panel-heading" style="padding-left:15px;padding-top: 0px;padding-bottom: 0px; background: linear-gradient(141deg, #460073 20%, #A100FF 65%); font-weight: bold; margin-top: -2.4%; color: white;">Admin Feedback Dashboard</div>
        <br />
        <div class="activity-box" *ngIf="dataLoader">
            <div class="loading-spiner"><img src="assets/img/loadingVer.gif" class="load" /></div>
        </div>
        <div class="panel-body">
            <div class="form-group row" style="margin-top:-2%;">
                <div class="col-sm-12">
                    <div class="form-group">
                        <div class="col-sm-3 formdivcaptions ">
                            <label for="txtEid">Enterprise ID</label>
                            <input type="text" class="form-control" id="txtEid" name="txtEid" [(ngModel)]="txtEid" autocomplete="off"/>    
                        </div>
                        <div class="col-sm-3 formdivcaptions">
                            <label for="dlstCountry4">Country</label>
                            <select id="dlstCountry4" name="dlstCountry4" [(ngModel)]="dlstCountries" style="height:33px" class="form-control ">
                                <option value="">&lt;--Select--&gt;</option>
                                <option *ngFor="let C of Countries">{{C.Country}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="formdivcaptions" style="margin-top:2%;">
                        <div align="left">
                            <button type="submit" id="btnSearch" class="btn btn-default btn-group-sm Button1" (click)="ShowData()"><span class="fa fa-search-plus" aria-hidden="true"></span> Search</button>&nbsp;&nbsp;&nbsp;&nbsp;
                            <button type="submit" id="searchClear" class="btn btn-default btn-group-sm Button1" (click)="Clear()"><span class="fa fa-close" aria-hidden="true"></span> Clear</button>
                        </div>
                    </div>
             </div>
             <div class="col-sm-12">
                <br />
                <div align="center"><span style="margin-left: 3%;  color:#000000; font-weight: bold; font-size: 15px; ">**Please select and submit maximum of 5 feedbacks to display in dashboard.**</span></div>
             </div>

            </div> 

            <div class="row table-responsive" id="divDetails" style="display:none;">
                <div style="margin-right: 20px;">
                    <table id="Detail" class="table table-bordered" border="1" style="margin-left: 9%; width: 90%; font-size: 13px; overflow: scroll;">
                        <thead style="background: linear-gradient(to bottom,#460073 0%, #A100FF 100%); filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#2e3b46', endColorstr='#2e3b46',GradientType=0 ); ">
                            <tr>
                                <th style="display:none">S.No</th>
                                <th style="width:100px;"><label style="width:30px; text-align :center;"><input type='checkbox' (click)="checkAll($event.target.checked)" id="selectedAll" name="selectedAll" title="selectedAll"/></label> </th>
                                <th style="text-align: center;min-width:150px;color:whitesmoke;">Enterprise ID</th>
                                <th style="text-align: center; min-width: 250px;color:whitesmoke;">Feedback</th>
                                <th style="text-align: center; min-width: 100px;color:whitesmoke;">Country</th>
                            </tr>    
                        </thead>
                        <tbody *ngFor="let data of successfulData.feedbacks">
                            <tr>
                                <td style="display:none;">{{data.Id}}</td>
                                <td>
                                    <label style="width:25px"><input type='checkbox' name="check" [(ngModel)]="data.checked"  id="contact{{data.Id}}" title="contact{{data.Id}}" style="margin-left:5px;"/></label>
                                </td>
                                <td>{{data.SubmittedBy}}</td>
                                <td>{{data.SuggestionFeedback}}</td>
                                <td>{{data.Country}}</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colspan="11" style="text-align: center;">
                                    <!-- pager -->
                                    <ul *ngIf="pager.pages && pager.pages.length" class="pagination">
                                        <li [ngClass]="{disabled:pager.currentPage === 1}">
                                            <a><i (click)="setPage(1)" class="icon-fast-backward"></i>
                                            </a>
                                        </li>
                                        <li [ngClass]="{disabled:pager.currentPage === 1}">
                                            <a><i (click)="setPage(pager.currentPage - 1)" class="icon-step-backward"></i></a>
                                        </li>
                                        <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
                                            <a (click)="setPage(page)">{{page}}</a>
                                        </li>
                                        <li *ngIf="(pager.totalPages - pager.startPage) > 5 ">
                                            <a (click)="setPage(pager.startPage + 5)">...</a>
                                        </li>
                                        <li *ngIf="(pager.totalPages - pager.startPage) > 5" >
                                            <a (click)="setPage(pager.totalPages)">{{pager.totalPages}}</a>
                                        </li>
                                        
                                        <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                                            <a><i (click)="setPage(pager.currentPage + 1)" class="icon-step-forward"></i></a>
                                        </li>
                                        <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                                            <a><i (click)="setPage(pager.totalPages)" class="icon-fast-forward"></i></a>
                                        </li>
                                    </ul>
                                </td>
                            </tr>
                        </tfoot>
                    </table>    
                </div>
                <div align="center">
                    <button type="submit" id="btnSubmit" class="btn btn-default btn-group-sm Button1" (click)="Submit()"><span class="fa fa-check-circle" aria-hidden="true"></span>Submit</button>
                </div>    
            </div>
        </div>    
    </div>
</form>